import * as bytemd from "bytemd";
import { getProcessor } from "bytemd";
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div");
};
var staticRenderFns$1 = [];
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(
        this,
        (options.functional ? this.parent : this).$root.$options.shadowRoot
      );
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __vue2_script$1 = {
  props: {
    value: String,
    plugins: Array,
    sanitize: Function,
    remarkRehype: Object,
    mode: String,
    previewDebounce: Number,
    placeholder: String,
    editorConfig: Object,
    locale: Object,
    uploadImages: Function,
    maxLength: Number
  },
  mounted() {
    const editor2 = new bytemd.Editor({
      target: this.$el,
      props: this.$props
    });
    editor2.$on("change", (e) => {
      this.$emit("change", e.detail.value);
    });
    this.editor = editor2;
  },
  watch: {
    $props: {
      handler(newValue, oldValue) {
        const copy = { ...newValue };
        for (let k in copy) {
          if (copy[k] === void 0) {
            delete copy[k];
          }
        }
        this.editor.$set(copy);
      },
      deep: true
    }
  }
};
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1,
  render$1,
  staticRenderFns$1,
  false,
  __vue2_injectStyles$1,
  null,
  null,
  null
);
function __vue2_injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
const editor = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "markdown-body",
    domProps: {
      "innerHTML": _vm._s(_vm.file)
    },
    on: {
      "click": function($event) {
        return _vm.handleClick($event);
      }
    }
  });
};
var staticRenderFns = [];
const __vue2_script = {
  props: ["value", "plugins", "sanitize", "remarkRehype"],
  computed: {
    file() {
      try {
        return getProcessor(this.$props).processSync(this.value);
      } catch (err) {
        console.error(err);
      }
    },
    needUpdate() {
      return [this.file, this.plugins, this.sanitize, this.remarkRehype];
    }
  },
  watch: {
    needUpdate: {
      handler(val) {
        this.off();
        this.$nextTick(() => {
          this.on();
        });
      },
      deep: true
    }
  },
  mounted() {
    this.on();
  },
  beforeDestroy() {
    this.off();
  },
  methods: {
    on() {
      if (this.plugins && this.file) {
        this.cbs = this.plugins.map(
          ({ viewerEffect }) => viewerEffect && viewerEffect({ markdownBody: this.$el, file: this.file })
        );
      }
    },
    off() {
      if (this.cbs) {
        this.cbs.forEach((cb) => cb && cb());
      }
    },
    handleClick(e) {
      const $ = e.target;
      if ($.tagName !== "A")
        return;
      const href = $.getAttribute("href");
      if (!href || !href.startsWith("#"))
        return;
      const dest = this.$el.querySelector("#user-content-" + href.slice(1));
      if (dest)
        dest.scrollIntoView();
    }
  }
};
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(
  __vue2_script,
  render,
  staticRenderFns,
  false,
  __vue2_injectStyles,
  null,
  null,
  null
);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
const viewer = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  editor as Editor,
  viewer as Viewer
};
